import { Action } from '@ngrx/store';
import { Loyalty } from '../reducers/loyalty.reducer';

export enum SharedLoyaltyActionsTypes {
  InitSharedLoyaltyConfig = '[SharedLoyalty] Init loyalty config',
  SetSharedLoyaltyConfig = '[SharedLoyalty] Set loyalty config',
}

export class InitSharedLoyaltyConfig implements Action {
  readonly type = SharedLoyaltyActionsTypes.InitSharedLoyaltyConfig;
}

export class SetSharedLoyaltyConfig implements Action {
  readonly type = SharedLoyaltyActionsTypes.SetSharedLoyaltyConfig;
  constructor(public payload: { loyaltyConfig: Loyalty }) {}
}

export type SharedLoyaltyActions =
  | InitSharedLoyaltyConfig
  | SetSharedLoyaltyConfig;
